import React, { useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { BidCards, getTyPoint, useBidHistory } from "./Bid";

const toInputDate = (date) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

// Bid dates may come as yyyy-mm-dd or dd-mm-yyyy (with "-" or "/"); returns yyyy-mm-dd or null
const normalizeBidDate = (value) => {
  const str = String(value || '');
  let m = str.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
  if (m) return `${m[1]}-${m[2].padStart(2, '0')}-${m[3].padStart(2, '0')}`;
  m = str.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
  if (m) return `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}`;
  const parsed = new Date(str);
  return isNaN(parsed) ? null : toInputDate(parsed);
};

const defaultFilters = () => {
  const today = new Date();
  const weekAgo = new Date();
  weekAgo.setDate(today.getDate() - 7);
  return { from: toInputDate(weekAgo), to: toInputDate(today), search: '', session: 'ALL' };
};

const AllBids = () => {
  const bids = useBidHistory();
  const [draft, setDraft] = useState(defaultFilters);
  const [applied, setApplied] = useState(defaultFilters);

  const updateDraft = (e) => {
    const { name, value } = e.target;
    setDraft((prev) => ({ ...prev, [name]: value }));
  };

  const resetFilters = () => {
    const initial = defaultFilters();
    setDraft(initial);
    setApplied(initial);
  };

  const filteredBids = useMemo(() => {
    const query = applied.search.trim().toLowerCase();
    return bids.filter((bid) => {
      const date = normalizeBidDate(bid.date);
      if (date && applied.from && date < applied.from) return false;
      if (date && applied.to && date > applied.to) return false;
      if (applied.session !== 'ALL' && bid.session !== applied.session) return false;
      if (query) {
        const haystack = `${bid.game_name} ${bid.game_type} ${getTyPoint(bid)}`.toLowerCase();
        if (!haystack.includes(query)) return false;
      }
      return true;
    });
  }, [bids, applied]);

  return (
    <div className="bid-screen">
      <form className="bid-filter" onSubmit={(e) => { e.preventDefault(); setApplied(draft); }}>
        <label>From
          <input type="date" name="from" value={draft.from} max={draft.to} onChange={updateDraft} />
        </label>
        <label>To
          <input type="date" name="to" value={draft.to} min={draft.from} onChange={updateDraft} />
        </label>
        <label className="span-2">Search market / panna
          <input type="search" name="search" value={draft.search} onChange={updateDraft} placeholder="Search market or panna..." />
        </label>
        <label className="span-2">Session
          <select name="session" value={draft.session} onChange={updateDraft}>
            <option value="ALL">All Sessions</option>
            <option value="Open">Open</option>
            <option value="Close">Close</option>
          </select>
        </label>
        <div className="bid-filter-actions">
          <button type="submit">Apply</button>
          <button type="button" className="bid-reset-btn" onClick={resetFilters}>Reset</button>
        </div>
      </form>

      <div className="bid-list">
        <BidCards
          bids={filteredBids}
          padding="0"
          emptyState={
            <div className="bid-empty">
              <FontAwesomeIcon icon={faMagnifyingGlass} />
              <p>No bid history found for selected filters.</p>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default AllBids;
